import React, { Component, Fragment } from "react";
import { animateScroll } from "react-scroll";
import Progress from "react-progressbar";
import { BarLoader } from "react-spinners";
import { css } from "@emotion/core";
import FileDialog from "./FileDialog";
import Firebase from "../firebasehelper";
const override = css`
  height: 5px;
  width: 100%;
`;
let profile = {};
class MessageInput extends Component {
  state = {
    value: "",
    modalIsOpen: false,
    caption: "",
    content: "",
    registering_status: "Creating Brand...",
    fileupload: 0,
    isDuplicate: false,
  };
  handleTouchStart = false;

  getStaticMessage() {
    const { message, addMessage } = this.props;
    return (
      <div
        className="message message-static"
        onClick={(e) => {
          this.handleTouchStart = true;
          this.submitBrandForReview();
        }}
        style={message.style}
      >
        {message.message}
      </div>
    );
  }

  checkEmailDuplicate = async (brandEmail) => {
    const foundInPending = await Firebase.findDuplicatePendingEmail(brandEmail);
    const isEmailExisting = await Firebase.isEmailExisting(brandEmail);
    return foundInPending || isEmailExisting;
  };

  getInputMessage() {
    const { value, isDuplicate } = this.state;
    const { message } = this.props;
    return (
      <div className="message-input-outer">
        <div className="message-input-container">
          <input
            type="text"
            value={value}
            placeholder={message.placeholder}
            onChange={this.onChange}
            onKeyPress={async (e) => {
              if (e.key === "Enter") {
                if (message.key === "email") {
                  const emailFound = await this.checkEmailDuplicate(value);
                  if (!emailFound) this.addMessage();
                  else alert("Sorry, this email is already in use.");
                } else if (
                  message.key === "brand" &&
                  (isDuplicate || (await this.checkPendingBrandDuplicate()))
                ) {
                  alert(
                    `Sorry, an Ecosystem with this name already exists. Please choose a different name.`
                  );
                } else {
                  if (value && !isDuplicate) {
                    this.addMessage();
                  }
                }
              }
            }}
            onFocus={() => {
              this.setState(
                {
                  isFocused: true,
                },
                () => {
                  animateScroll.scrollToBottom({
                    duration: 500,
                    smooth: "easeInOutQuad",
                  });
                }
              );
            }}
            onBlur={() => {
              this.setState({
                isFocused: false,
              });
            }}
          />
          <div
            className={`send-button ${value && !isDuplicate ? "" : "disabled"}`}
            style={{ cursor: "pointer" }}
            onClick={async (e) => {
              if (message.key === "email") {
                const emailFound = await this.checkEmailDuplicate(value);
                if (!emailFound) this.addMessage();
                else alert("Sorry, this email is already in use.");
              } else if (message.key === "brand") {
                const exists = await this.checkPendingBrandDuplicate();
                if (!exists) this.addMessage();
                else {
                  alert(
                    `Sorry, an Ecosystem with this name already exists. Please choose a different name.`
                  );
                }
              } else {
                if (value && !isDuplicate) {
                  if (this.handleTouchStart) {
                    setTimeout(() => {
                      this.handleTouchStart = false;
                    }, 1000);
                    e.preventDefault();
                    return;
                  }
                  this.handleTouchStart = true;
                  this.addMessage();
                }
              }
            }}
          >
            Go
          </div>
        </div>
      </div>
    );
  }

  getUploadDialog() {
    const { message } = this.props;
    return <FileDialog upload={this.upload} message={message} />;
  }

  upload = (file) => {
    const { addMessage, message } = this.props;
    var metadata = {
      contentType: "image/png",
    };
    var storageRef = Firebase.storage().ref();
    var uploadTask;
    if (message.key === "logo")
      uploadTask = storageRef
        .child("brand_logo/" + profile["brand"])
        .put(file, metadata);
    else
      uploadTask = storageRef
        .child("brand_icon/" + profile["brand"])
        .put(file, metadata);
    let storage = Firebase.getStorage();
    let self = this;
    uploadTask.on(
      storage.TaskEvent.STATE_CHANGED,
      function (snapshot) {
        let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        self.setState({ fileupload: progress });
        console.log("Upload is " + progress + "% done");
      },
      function (error) {
        console.log(error.code);
      },
      function () {
        uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
          profile[message.key] = downloadURL;
          console.log("url", downloadURL);
          addMessage({
            message: "Image uploaded.",
            ...message,
          });
        });
      }
    );
  };

  checkPendingBrandDuplicate = async () => {
    const brandName = this.state.brandName.toLowerCase();
    return await Firebase.findDuplicatePendingBrand(brandName);
  };

  checkPendingEmailDuplicate = async (email) => {
    const brandEmail = email.toLowerCase();
    return await Firebase.findDuplicatePendingEmail(brandEmail);
  };

  checkBrandNameDuplicate = (brand_name) => {
    const lowercaseName = brand_name.toLowerCase();
    const { brands } = this.props;
    const found = brands.find(
      (brand) => brand.name.toLowerCase() === lowercaseName
    );
    if (found) return true;
    return false;
  };

  onChange = (e) => {
    const { message } = this.props;
    if (message.key === "brand") {
      const brand_name = e.target.value.trim();
      this.setState({ brandName: brand_name });
      if (!brand_name) this.setState({ isnext: false });
      if (this.checkBrandNameDuplicate(brand_name)) {
        this.setState({ isDuplicate: true, isnext: false });
      } else {
        this.setState({ isDuplicate: false });
      }
    } else if (message.key === "email") {
      const email = e.target.value.trim();
      if (!email) this.setState({ isnext: false });
      if (this.checkPendingEmailDuplicate(email)) {
        this.setState({ isDuplicate: true, isnext: false });
      } else {
        console.log("else duplicate false");
        this.setState({ isDuplicate: false });
      }
    }
    this.setState({
      value: e.target.value,
    });
  };

  createPincode = () => {
    return Math.floor(100000 + Math.random() * 900000);
  };

  jsUcfirst(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  addMessage = async () => {
    const { addMessage, message } = this.props;
    console.log("message", message);
    const { value } = this.state;
    addMessage({
      type: "user",
      message: value,
      key: message.key,
      inputType: "input",
      result: message.result,
    });
    if (!message.finish) {
      // console.log("final profile", profile);
      // this.registerBrand();
      profile[message.key] = value;
    }
  };

  componentWillLeave(callback) {
    const { message } = this.props;
    if (message.inputType !== "input") {
      this.setState({
        leaving: true,
      });
      setTimeout(() => {
        callback();
      }, 400);
    } else callback();
  }

  closeModal = () => {
    this.setState({ modalIsOpen: false });
  };

  getIPAddress = async () => {
    try {
      const ipifyRes = await fetch("https://api.ipify.org/?format=json", {
        method: "GET",
      });
      const { ip } = await ipifyRes.json();
      return ip;
    } catch (err) {
      console.log("getIPAddress() error", err);
    }
  };

  submitBrandForReview = async () => {
    const ip = await this.getIPAddress();

    try {
      const brandData = {
        logo: profile.logo,
        website: profile.website.toLowerCase().trim(),
        hexcode: profile.hexcode || "#FAFAFA",
        icon: profile.icon,
        brand: profile.brand.trim(),
        firstname: profile.firstname.trim(),
        email: profile.email.toLowerCase().trim(),
        territory: profile.territory || "UK",
        umbrella: false,
        ipAddress: ip,
      };
      const res = await Firebase.submitBrandForReview(brandData);
      if (res.success) {
        alert(
          "Your details have been successfully submitted for the review process. If your application is successful, an email containing a temporary password will be sent to your inbox, granting you access to your exclusive Ecosystem. Please keep an eye on your email inbox. Thank you!"
        );
        setTimeout(() => {
          this.props.history.push("/");
        }, 300);
      } else alert(`${res.message}. Please try again.`);
    } catch (err) {
      console.log("submitBrandForReview() error", err);
      alert(
        "Sorry, we a encountered an error submitting your details. Please try again."
      );
    }
  };
  render() {
    const { leaving, fileupload, registering, registering_status } = this.state;
    const { message } = this.props;
    return (
      <Fragment>
        {message && !registering && (
          <div
            className={`message-input-wrapper ${message.inputType} ${
              leaving ? "leaving" : ""
            }`}
          >
            {message.inputType === "static" ? this.getStaticMessage() : null}
            {message.inputType === "input" ? this.getInputMessage() : null}
            {message.inputType === "upload" ? this.getUploadDialog() : null}
          </div>
        )}
        {registering && <p>{registering_status}</p>}
        {registering && <BarLoader css={override} sizeUnit={"px"} />}
        <Progress completed={fileupload} />
      </Fragment>
    );
  }
}

export default MessageInput;



// WEBPACK FOOTER //
// ./src/components/MessageInput.js